import $ from 'jquery';

export const GetQueryString = () => {
    var search = window.location.search.substring(1);
    if(!search)
        return {};
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) });
}

export const SetQueryString = (data) => {
    var result = $.param(data);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + result + window.location.hash;
    window.history.replaceState("", "", newurl);
}

export const SetParamQueryString = (name, value) => {
    var current = GetQueryString();
    current[name] = value;
    SetQueryString(current);
}

export const AssignObjectToQueryString = (data) => {
    var output = GetQueryString();
    output = {
        ...output,
        ...data
    };
    SetQueryString(output);
}
